require('./cardChangePaymentMethodStep1.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @ actions
const cardChangePaymentMethodActions = require('actions/cardChangePaymentMethod');
const revolvingActions = require('actions/cardRevolvingDocuments');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ components
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ commons
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { AFISimulator } = require('components/cards/AFISimulator/AFISimulator');

const { getTooltipOptions, getInterests, getCardType } = require('utilities/cardsHelper');

// @ constants
const {
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_VARIABLE,
} = require('constants/index');

class CardChangePaymentMethodStep1 extends React.Component {
    static constants = {
        CALCULATION_TYPE_FIXED_FEE: 0,
        CALCULATION_TYPE_VARIABLE_FEE: 1,
        FRAME_BORDER: "0",
        SCROLLING: "no",
        TITLE: "título",
        APLAZADO_TIN: 'aplazado_tin',
        APLAZADO_TAE: 'aplazado_tae'
    }

    constructor(props) {
        super(props);
        const cardType = getCardType(props.immCard);
        const geValueByType = this.getCardData(cardType);
        const { immCardChangePaymentMethod } = this.props;

        this.state = {
            isShowInfoCC: false,
            isShowBottomCC: false,
            installmentHasChanged: immCardChangePaymentMethod.getIn(['steps', 0, 'proccessInit']),
            tin: geValueByType(CardChangePaymentMethodStep1.constants.APLAZADO_TIN),
            tae: geValueByType(CardChangePaymentMethodStep1.constants.APLAZADO_TAE)
        }
    }

    componentWillMount() {
        this.setDefaultSelectedInstallmentOption();
    }

    componentDidMount() {
        if (this.isCardForRevolving()) {
            const {
                method,
                setInneParams,
            } = this.props;
            const {installmentHasChanged, tin, tae} = this.state;

            setInneParams({
                tin,
                tae
            });

            if (!installmentHasChanged){
                this.setDisabledNextButton();
            } else {
                this.setMessagesCC(method);
            }
        }
    }

    isCardForRevolving() {
        const {showIneAndRevolving, immCard} = this.props;
        const isForRevolvingProcess = immCard.get('isForRevolvingProcess');
        return isForRevolvingProcess && showIneAndRevolving;
    }

    getInstallmentsOptions() {
        const {method, immCardChangePaymentMethod} = this.props;

        switch (method) {
            case CARD_PAYMENT_METHOD_FIXED:
                return immCardChangePaymentMethod.getIn(['steps', 0, 'fixedInstallments', 'options']);
            case CARD_PAYMENT_METHOD_VARIABLE:
                return immCardChangePaymentMethod.getIn(['steps', 0, 'variableInstallments', 'options']);
            default:
                return false;
        }
    }

    setDefaultSelectedInstallmentOption() {
        const {installments} = this.props;
        const installmentsOptions = this.getInstallmentsOptions();

        if (installmentsOptions && !this.isCardForRevolving()) {
            const defaultInstallmentOption = installmentsOptions.get(0).toJS();

            if (!installments && defaultInstallmentOption) {
                this.props.setInstallments(defaultInstallmentOption.value);
            }
        }
    }

    buildDisabledTooltip(message) {
        return (
            <OKTooltip
                content="cardChangePaymentMethod-variableEmpty"
                offset={[0, -15]}
                target={
                    <span>
                        {message}
                    </span>
                }
            />
        )
    }

    buildInstallmentsOptions() {
        const { installments, method, immCardChangePaymentMethod } = this.props;
        const noResultsText = formatText('cardChangePaymentMethod-noResultText');
        let installmentsOptions = this.getInstallmentsOptions();
        let content = (<div></div>);

        if (installmentsOptions) {
            installmentsOptions = installmentsOptions.toJS();

            let extraContent;
            if (method === CARD_PAYMENT_METHOD_VARIABLE) {
                extraContent = (
                    <FormattedText
                        value="cardChangePaymentMethod-installmentAmountVariable"
                        injectedStrings={[immCardChangePaymentMethod.getIn(['steps', 0, 'fixedInstallments', 'min'], 15)]}
                        className="card-change-payment-method-step-one__installment-amount"
                    />
                );
            }

            content = (
                <div>
                    <article className="card-change-payment-method-step-one__section--second">
                        <header className="card-change-payment-method-step-one__header">
                            <FormattedText
                                value="cardChangePaymentMethod-installments"
                                className="card-change-payment-method-step-one__title"
                            />
                        </header>
                        <FormattedText
                            value="cardChangePaymentMethod-monthlyInstallment"
                            className="card-change-payment-method-step-one__monthly-installment"
                        />
                        <section className="card-change-payment-method-step-one__content">
                            <form>
                                <fieldset>
                                    <OKSelect
                                        name="form-field-installments"
                                        className="dropdown-accounts"
                                        onChange={this.handleInstallmentsChange}
                                        options={installmentsOptions}
                                        value={installments}
                                        searchable={true}
                                        clearable={false}
                                        noResultsText={noResultsText}
                                    />
                                </fieldset>
                            </form>
                        </section>
                        {extraContent}
                    </article>
                </div>
            );
        }

        return content;
    }

    buildPaymentTypeTooltip() {
        const { immCard, immGlobalVariables } = this.props;
        const options = [
            {
                label: formatText(getTooltipOptions('cardChangeAndHirePaymentMethod-tooltipOptionsFirstLabel', getCardType(immCard))),
                value: formatText(getTooltipOptions('cardChangeAndHirePaymentMethod-tooltipOptionsFirstText', getCardType(immCard)))
            },
            {
                label: formatText(getTooltipOptions('cardChangeAndHirePaymentMethod-tooltipOptionsSecondLabel', getCardType(immCard))),
                value: formatText(getTooltipOptions('cardChangeAndHirePaymentMethod-tooltipOptionsSecondText', getCardType(immCard)))
            },
            {
                label: formatText(getTooltipOptions('cardChangeAndHirePaymentMethod-tooltipOptionsThirdLabel', getCardType(immCard))),
                value: formatText(getTooltipOptions('cardChangeAndHirePaymentMethod-tooltipOptionsThirdText', getCardType(immCard)))
            },
        ].map((option, index) => (
            <section key={index}>
                <span className="card-change-payment-method-step-one__tooltip-title">{option.label}</span>
                <span className="card-change-payment-method-step-one__tooltip-text">{option.value}</span>
            </section>
        ));

        const interestObject = getInterests(immGlobalVariables, immCard)
        const { interestMn, interestTin, interestTae } = interestObject

        return (
            <article>
                {options}
                <footer className="card-change-payment-method-step-one__tooltip-footer">
                    <FormattedText
                        value={getTooltipOptions('cardChangeAndHirePaymentMethod-tooltipLastMessagePercentages', getCardType(immCard))}
                        injectedStrings={[
                            interestMn,
                            interestTin,
                            interestTae
                        ]}
                        className="card-change-payment-method-step-one__tooltip-text"
                    />
                </footer>
            </article>
        );
    }

    handleInstallmentsChange = (selected) => {
        const {setInstallments, method} = this.props;
        setInstallments(selected.value);

        this.setState({installmentHasChanged: true});
        this.setMessagesCC(method);
        this.setDisabledNextButton(false);
    }

    handleMethodChange = (value) => {
        this.props.setMethod(value, () => {
            this.setDefaultSelectedInstallmentOption();
        });

        this.setState({installmentHasChanged: this.isPaymentMethodUnique(value)});
        this.setDisabledNextButton();
        this.enableButtonInUniqueMethod(value);
        this.setMessagesCC(value);
    }

    setMessagesCC = (method) => {
        this.setState({
            isShowInfoCC: !this.isPaymentMethodUnique(method),
            isShowBottomCC: true,
        });
    }

    setDisabledNextButton(isDisabled = true) {
        this.props.setDisabledButton(isDisabled);
    }

    isPaymentMethodUnique(method) {
        return method === CARD_PAYMENT_METHOD_UNIQUE;
    }

    enableButtonInUniqueMethod(method) {
        if (this.isPaymentMethodUnique(method)) {
            this.setDisabledNextButton(false);
        }
    }

    tooltipTranslation() {
        const { immCard } = this.props;
        const isDiamondOrPremiumCard = immCard.get('isDiamond') || immCard.get('isPremium');
        const isViaT = immCard.get('isViaT');
        if(isDiamondOrPremiumCard) {
            return 'tooltipAmountsExampleDiamondPremium';
        } else if (isViaT) {
            return 'tooltipAmountsExampleViaT';
        }
        return 'tooltipAmountsExample';
    }

    buildTooltipMethod(message) {
        return (
            <div>
                {message}
                &nbsp;
                <OKTooltip
                    content={<FormattedText value={`cardChangePaymentMethod-${this.tooltipTranslation()}`}/>}
                    offset={[0, -15]}
                    type="custom"
                />
            </div>
        );
    }

    getCardData = (creditType) => {
        const {
            immGlobalVariables,
            revolvingPackId,
        } = this.props;

        return (type) => {
            const values = {
                'OPEN_CREDIT_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', type]),
                'DIAMOND_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', type]),
                'PREMIUM_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', type]),
                'REVOLVING_CARD': immGlobalVariables.getIn(['variables', 'parameters', `revolving_pack_${revolvingPackId}`, type]),
                'VIAT_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', type]),
            };

            return values[creditType];
        }
    }

    buildBottomMessageCC() {
        const { installmentHasChanged } = this.state;
        const isRender = __CONTACT_CENTER__ && this.isCardForRevolving() && installmentHasChanged && this.state.isShowBottomCC;

        return !!isRender && (
            <BlockInfo extraClass="cancel-bizum-step1__block-info">
                <span>
                    <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_FotterInfoCC"/>
                </span>
            </BlockInfo>
        )
    }

    render() {
        const {
            immCard,
            immCardChangePaymentMethod,
            installments,
            method,
        } = this.props;
        const fixedPaymentRadioLabel = formatText('cardChangePaymentMethod-unique');
        const fixedInstallmentsRadioText = formatText('cardChangePaymentMethod-fixed');
        const variableInstallmentsRadioText = formatText('cardChangePaymentMethod-variable');
        const variableInstallmentsIsEmpty = immCardChangePaymentMethod.getIn(['steps', 0, 'variableInstallments']).isEmpty();
        const fixedInstallmentsIsEmpty = immCardChangePaymentMethod.getIn(['steps', 0, 'fixedInstallments']).isEmpty();
        const installmentsSection = this.buildInstallmentsOptions();
        const showAFISimulator = this.isCardForRevolving() && !this.isPaymentMethodUnique(method) && installments && this.state.installmentHasChanged;

        let content;
        let fixedInstallmentsRadioLabel;
        let variableInstallmentsRadioLabel;

        if (fixedInstallmentsIsEmpty) {
            fixedInstallmentsRadioLabel = this.buildDisabledTooltip(fixedInstallmentsRadioText);
        } else {
            if (method === CARD_PAYMENT_METHOD_FIXED) {
                fixedInstallmentsRadioLabel = this.buildTooltipMethod(fixedInstallmentsRadioText);
            } else {
                fixedInstallmentsRadioLabel = fixedInstallmentsRadioText;
            }
        }

        if (variableInstallmentsIsEmpty) {
            variableInstallmentsRadioLabel = this.buildDisabledTooltip(variableInstallmentsRadioText);
        } else {
            variableInstallmentsRadioLabel = variableInstallmentsRadioText;
        }

        if (immCardChangePaymentMethod.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const tooltipContent = this.buildPaymentTypeTooltip();

            let paymenMethodOptions = [
                <RadioButton
                    key="0"
                    disabled={fixedInstallmentsIsEmpty}
                    label={fixedInstallmentsRadioLabel}
                    value={CARD_PAYMENT_METHOD_FIXED}
                    className="card-change-payment-method-step-one__radio"
                />,
                <RadioButton
                    key="1"
                    disabled={variableInstallmentsIsEmpty}
                    label={variableInstallmentsRadioLabel}
                    value={CARD_PAYMENT_METHOD_VARIABLE}
                    className="card-change-payment-method-step-one__radio"
                />
            ];

            if (!immCard.get('isRevolving')) {
                paymenMethodOptions.push(
                    <RadioButton
                        key="2"
                        label={fixedPaymentRadioLabel}
                        value={CARD_PAYMENT_METHOD_UNIQUE}
                        className="card-change-payment-method-step-one__radio"
                    />
                );
            }

            content = (
                <section className="card-change-payment-method-step-one__content">
                    <FormattedText
                        value="cardChangePaymentMethod-paymentTypeSelection"
                        className="card-change-payment-method-step-one__subtitle"
                    />
                    <OKTooltip
                        content={tooltipContent}
                        placement="top"
                        offset={[0, -15]}
                        type="custom"
                    />
                    <form>
                        <fieldset>
                            <RadioButtonGroup
                                name="method"
                                idPrefix="methodRadio"
                                selectedValue={method}
                                onChange={this.handleMethodChange}
                                className="card-change-payment-method-step-one__radio-group"
                            >
                                {paymenMethodOptions}
                            </RadioButtonGroup>
                        </fieldset>
                    </form>
                </section>
            );
        }

        let afiSimulatorContent;

        if (!!showAFISimulator) {
            afiSimulatorContent = (
                <AFISimulator
                    amount={immCard.getIn(['limit', 'amount'])}
                    immCard={immCard}
                    immGlobalVariables={this.props.immGlobalVariables}
                    installments={this.props.installments}
                    method={method}
                />
            );
        }

        return (
            <section className="card-change-payment-method-step-one">
                <article className="card-change-payment-method-step-one__section">
                    <header className="card-change-payment-method-step-one__header">
                        <FormattedText
                            value="cardChangePaymentMethod-paymentMethod"
                            className="card-change-payment-method-step-one__title"
                        />
                    </header>
                    <FormattedText
                        value="cardChangePaymentMethod-warningMessage"
                        className="card-change-payment-method-step-one__warning-message"
                    />
                    {content}
                </article>
                {installmentsSection}
                <br/>
                {afiSimulatorContent}
                {this.buildBottomMessageCC()}
            </section>
        )
    }
}

CardChangePaymentMethodStep1.propTypes = {
    immCard: PropTypes.object,
    immCardChangePaymentMethod: PropTypes.object,
    immGlobalVariables: PropTypes.object,
    method: PropTypes.string,
    installments: PropTypes.number,
    immFlagBasedFeatures: PropTypes.object,
    setAFIParams: PropTypes.func,
    setInneParams: PropTypes.func,
    setInstallments: PropTypes.func,
    setMethod: PropTypes.func,
    revolvingPackId: PropTypes.number,
    showIneAndRevolving: PropTypes.bool,
    setDisabledButton: PropTypes.func,
};

module.exports.constructor = CardChangePaymentMethodStep1;
module.exports.CardChangePaymentMethodStep1 = connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immHireCardRevolving: state.hireCardRevolving,
    }),
    {
        setAFIParams: revolvingActions.setAFIParams,
        setMethod: cardChangePaymentMethodActions.setMethod,
        setInstallments: cardChangePaymentMethodActions.setInstallments,
        setInneParams: revolvingActions.setInneParams,
        setDisabledButton: cardChangePaymentMethodActions.setDisabledButton,
    }
)(CardChangePaymentMethodStep1);
